import React from "react";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";

import common_en from '../../translations/en/common.json'
import common_es from '../../translations/es/common.json'

i18next.init({
  interpolation: { escapeValue: false }, // React already does escaping
  lng: "es", // language to use
  resources: {
    en: {
      common: common_en, // 'common' is our custom namespace
    },
    es: {
      common: common_es,
    },
  },
});

const TranslationProvider = ({ children }) => {
  return <I18nextProvider i18n={i18next}>{children}</I18nextProvider>;
};

export default TranslationProvider;
